var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile-wallets-checkout py-1"},[(_vm.loading)?_c('div',{staticClass:"text-center mx-auto mt-4 mb-8"},[_c('v-progress-circular',{attrs:{"indeterminate":"","transition":"fade-transition","color":"teal darken-3","size":"30","width":"2"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }